import React, { useState } from 'react';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "What's the biggest challenge for my call center, and how does ConvaLytics AI help?",
      answer: "The biggest challenge is the overwhelming amount of unstructured data. With 95% of calls going unanalyzed, you're missing crucial insights that could boost revenue and improve customer satisfaction. ConvaLytics AI solves this by giving you a powerful, AI-driven solution that provides clear, actionable insights from every single call."
    },
    {
      question: "What makes ConvaLytics AI different from just transcribing calls?",
      answer: "We go far beyond simple transcription. Our AI analyzes the sentiment and emotion behind every conversation, giving you a deeper understanding of what your customers and agents are truly feeling. We also categorize calls by type and outcome, score agent performance, and even provide real-time coaching suggestions. It's not just about what was said—it's about what it all means for your business."
    },
    {
      question: "Is ConvaLytics AI difficult to set up or use?",
      answer: "We've designed our platform to be user-friendly. Our goal is to make call analytics smarter, faster, and more powerful for you. The product features a simple dashboard with at-a-glance insights and tools for team management, so you can easily track performance and get the information you need. We handle the complex AI processing, so you can focus on making data-driven decisions."
    },
    {
      question: "Can ConvaLytics AI help me improve my team's performance?",
      answer: "Absolutely. Our platform is built to help your team succeed. We score agent performance across multiple dimensions and identify specific improvement opportunities. We even provide coaching and recommendations to help your agents grow and perform better. Our goal is to empower your team to provide the best possible service."
    },
    {
      question: "I'm a small or mid-sized business. Is this product right for me?",
      answer: "Yes, our solution is specifically designed for SMBs and the mid-market. We understand your need to compete with larger players, and our platform gives you the sophisticated tools you need to gain a competitive advantage without the high costs or complexity of legacy systems."
    },
    {
      question: "What if my data needs to be secure?",
      answer: "ConvaLytics AI is committed to helping you manage compliance risk. The platform is designed to provide you with a comprehensive overview of your call data, which helps you maintain records and stay on top of regulatory requirements."
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-heading">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Get answers to the most common questions about ConvaLytics AI
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200">
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-lg font-semibold text-gray-900">
                  {faq.question}
                </span>
                <svg
                  className={`w-5 h-5 text-gray-500 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600">
            Feel free to mail us for any enquiries: <a href="mailto:support@convalyticsai.com" className="text-primary-600 hover:text-primary-700">support@convalyticsai.com</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
